import { FieldNamesMarkedBoolean } from 'react-hook-form';
import { IGlobalItem } from 'src/components/CreateGlobalItemWizard/types';
import { getDirtyFields } from '../getDirtyFields/getDirtyFields';
import { formUpdateGlobalItemRequestData } from '../formUpdateGlobalItemRequestData/formUpdateGlobalItemRequestData';
import { formatFlagsToRegulatoryStatements } from 'src/utils/regulatory-statements';

export const dirtyFieldsToFilter = {
  containsAlcohol: 'containsAlcohol',
  is_hfss: 'is_hfss',
  age_verification: 'age_verification',
} as const;

// Fields that should be excluded from the update payload (handled separately via formatFlagsToRegulatoryStatements)
const EXCLUDED_FIELDS: Set<string> = new Set([
  dirtyFieldsToFilter.containsAlcohol,
  dirtyFieldsToFilter.is_hfss,
  dirtyFieldsToFilter.age_verification,
]);

export const formUpdateDetailsPayload = (
  data: Partial<IGlobalItem>,
  dirtyFields: Partial<Readonly<FieldNamesMarkedBoolean<IGlobalItem>>>,
) => {
  const dirtyFieldsKeys = getDirtyFields(dirtyFields);
  const requestData = formUpdateGlobalItemRequestData(
    dirtyFieldsKeys.filter((item) => !EXCLUDED_FIELDS.has(item)),
    data,
  );

  const hasRegulatoryStatementChanges = dirtyFieldsKeys.some((item) => EXCLUDED_FIELDS.has(item));

  return {
    data: JSON.stringify({
      ...requestData,
      ...(hasRegulatoryStatementChanges ? formatFlagsToRegulatoryStatements(data) : {}),
    }),
    ...(dirtyFieldsKeys.includes('image') && { files: data.image || null }), // files included only if they are changed
  };
};
